import React from 'react';

interface DotIndicatorsProps {
  totalSlides: number;
  currentSlide: number;
  onDotClick: (index: number) => void;
}

/**
 * Dot indicators for carousel navigation
 * Provides visual feedback and direct slide navigation
 */
export function DotIndicators({ totalSlides, currentSlide, onDotClick }: DotIndicatorsProps) {
  if (totalSlides <= 1) {
    return null;
  }

  return (
    <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex z-10">
      {Array.from({ length: totalSlides }, (_, index) => {
        const isActive = index === currentSlide;
        return (
          <button
            key={index}
            type="button"
            onClick={() => onDotClick(index)}
            className="inline-flex items-center justify-center w-6 h-6 bg-transparent cursor-pointer"
            aria-label={`Go to slide ${index + 1}`}
            aria-current={isActive ? 'true' : undefined}
          >
            <span
              aria-hidden="true"
              className={`block w-2 h-2 rounded-full transition-all duration-200 ${
                isActive ? 'bg-primary-400 scale-110' : 'bg-white'
              }`}
            />
          </button>
        );
      })}
    </div>
  );
}
